import { render, staticRenderFns } from "./CreateSelfServiceTemplateModal.vue?vue&type=template&id=723bc567&scoped=true"
import script from "./CreateSelfServiceTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateSelfServiceTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateSelfServiceTemplateModal.vue?vue&type=style&index=0&id=723bc567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723bc567",
  null
  
)

export default component.exports